import React from 'react'
import { Link } from 'react-router-dom'
import Cart_1 from '../../../assets/images/shop/product-slider-3.jpg'
import Cart_2 from '../../../assets/images/shop/product-1.png'
import Cart_3 from '../../../assets/images/shop/product-6.png'


const Cart = () => {
    return (
        <>
            <div className="cart-section">
                <div className="container">
                    <div
                        className="cart-product-heading animate fadeInRight wow"
                        data-wow-duration="1500ms"
                        data-wow-delay="200ms"
                    >
                        <div className="row">
                            <div className="col-md-6">
                                <div className="cart-heading text-center">
                                    <h4>Product</h4>
                                </div>
                            </div>
                            <div className="col-md-6 cart-product-heading-md-none">
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="cart-heading">
                                            <h4>Price</h4>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="cart-heading text-center">
                                            <h4>Quantity</h4>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="cart-heading text-center">
                                            <h4>Subtotal</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="cart-product-single-box animate fadeInRight wow"
                        data-wow-duration="1500ms"
                        data-wow-delay="400ms"
                    >
                        <div className="row gutter-y-20 align-items-center">
                            <div className="col-md-6 col-sm-6 col-6">
                                <div className="cart-product-info">
                                    <div className="cancel-product">
                                        <Link to="#">
                                            <i className="fa-solid fa-xmark" />
                                        </Link>
                                    </div>
                                    <div className="cart-product-image">
                                        <img
                                            width={100}
                                            height={100}
                                            src={Cart_1}
                                            alt="product-image"
                                        />
                                    </div>
                                    <div className="cart-product-name">
                                        <h6>Air Pod Pro 2023</h6>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-sm-6 col-6">
                                <div className="row align-items-center cart-discription">
                                    <div className="col-md-4">
                                        <div className="price">
                                            <p>$25.00</p>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="cart-product-count text-center">
                                            <div className="product-cart-info">
                                                <div className="product-cart-info-box">
                                                    <Link to="#" className="minus">
                                                        <i className="fa-solid fa-minus" />
                                                    </Link>
                                                    <span className="product-item-count">1</span>
                                                    <Link to="#" className="plus">
                                                        <i className="fa-solid fa-plus" />
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="total-price text-center">
                                            <p>$25.00</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="cart-product-single-box animate fadeInRight wow"
                        data-wow-duration="1500ms"
                        data-wow-delay="600ms"
                    >
                        <div className="row align-items-center">
                            <div className="col-md-6 col-sm-6 col-6">
                                <div className="cart-product-info">
                                    <div className="cancel-product">
                                        <Link to="#">
                                            <i className="fa-solid fa-xmark" />
                                        </Link>
                                    </div>
                                    <div className="cart-product-image">
                                        <img
                                            width={100}
                                            height={100}
                                            src={Cart_2}
                                            alt="product-image"
                                        />
                                    </div>
                                    <div className="cart-product-name">
                                        <h6>Water bottle</h6>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-sm-6 col-6">
                                <div className="row align-items-center cart-discription">
                                    <div className="col-md-4">
                                        <div className="price">
                                            <p>$10.00</p>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="cart-product-count text-center">
                                            <div className="product-cart-info">
                                                <div className="product-cart-info-box">
                                                    <Link to="#" className="minus">
                                                        <i className="fa-solid fa-minus" />
                                                    </Link>
                                                    <span className="product-item-count">2</span>
                                                    <Link to="#" className="plus">
                                                        <i className="fa-solid fa-plus" />
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="total-price text-center">
                                            <p>$20.00</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="cart-product-single-box animate fadeInRight wow"
                        data-wow-duration="1500ms"
                        data-wow-delay="800ms"
                    >
                        <div className="row align-items-center">
                            <div className="col-md-6 col-sm-6 col-6">
                                <div className="cart-product-info">
                                    <div className="cancel-product">
                                        <Link to="#">
                                            <i className="fa-solid fa-xmark" />
                                        </Link>
                                    </div>
                                    <div className="cart-product-image">
                                        <img
                                            width={100}
                                            height={100}
                                            src={Cart_3}
                                            alt="product-image"
                                        />
                                    </div>
                                    <div className="cart-product-name">
                                        <h6>T-shirt</h6>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-sm-6 col-6">
                                <div className="row align-items-center cart-discription">
                                    <div className="col-md-4">
                                        <div className="price">
                                            <p>$45.00</p>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="cart-product-count text-center">
                                            <div className="product-cart-info">
                                                <div className="product-cart-info-box">
                                                    <Link to="#" className="minus">
                                                        <i className="fa-solid fa-minus" />
                                                    </Link>
                                                    <span className="product-item-count">1</span>
                                                    <Link to="#" className="plus">
                                                        <i className="fa-solid fa-plus" />
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="total-price text-center">
                                            <p>$45.00</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="cart-lower">
                        <div className="row gutter-y-40">
                            <div className="col-lg-6">
                                <div
                                    className="cupen-code animate fadeInLeft wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="200ms"
                                >
                                    <form action="#">
                                        <input
                                            type="text"
                                            placeholder="Coupon Code"
                                            className="form-control"
                                        />
                                        <button type="submit" className="btn btn-secondary btn-theme">
                                            Apply Coupon
                                        </button>
                                        <Link to="/Shop" className="btn btn-primary btn-theme">
                                            Update Cart
                                        </Link>
                                    </form>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div
                                    className="cart-total animate fadeInRight wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="200ms"
                                >
                                    <h4>Cart totals</h4>
                                    <ul>
                                        <li>
                                            <h6>Subtotal</h6>
                                            <p>$90.00</p>
                                        </li>
                                        <li>
                                            <h6>Total</h6>
                                            <p>$90.00</p>
                                        </li>
                                    </ul>
                                    <Link to="/CheckOut" className="btn btn-secondary btn-theme">
                                        Proceed to checkout
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Cart
